import React from 'react';
import { HStack, Stack } from '@chakra-ui/react';
import { useColors } from '../../../components/common/Color';
import LeftFormSection from './Left/Left_Deteils';
import RightFormSection from './Right/Right_details';

import HeaderSection from '../../../components/common/Header/HeaderSection';

function Student_profile() {
  const colors = useColors();

  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Profile"
        breadcrumb={["Dashboard", "Profile"]}
      />

      <Stack
        direction={{ base: 'column', md: 'row' }} // Stack the items in column on small screens and row on larger screens
        align="start"
        gap={6}
        p={6}
      >
        <LeftFormSection colors={colors} />
        <RightFormSection colors={colors} />
      </Stack>
    </div>
  );
}

export default Student_profile;
